import React from 'react'
import { pluralizeToString } from 'lib/string/pluralize'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import FlashMobileStickyHeaderFilters from 'components/OfferPage/FlashHotel/FlashHotelMobileVariant/FlashMobileStickyHeaderFilters'
import MobileMultipleRoomsBookingContent from '../MobileMultipleRoomsBookingContent'

interface Props {
  rooms?: Array<App.RoomOccupants>;
  onClose: () => void;
  onBack?: () => void;
}

const defaultRooms = [generateRoomOccupants()]

function MobileMultipleRoomsBookingSelectRoomsModal(props: Props) {
  const { rooms = defaultRooms, onClose, onBack } = props

  return (
    <>
      <ModalHeader
        title={`Select your ${pluralizeToString('room', rooms.length)}`}
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <FlashMobileStickyHeaderFilters onAfterCloseCapacity={onClose} />
      </ModalHeader>
      <ModalBody>
        <MobileMultipleRoomsBookingContent />
      </ModalBody>
    </>
  )
}

type MappedProps = Pick<Props, 'rooms'>

export default withOfferPageAndReduxState((state: OfferPageState): MappedProps => ({
  rooms: state.rooms,
}), MobileMultipleRoomsBookingSelectRoomsModal)
